<template>
    <DeclineAttentionPopup
        v-if="isShowAttentionDecline"
        @confirmDecline="confirmAttentionDecline"
        @close="closeDecline"
    />
    <DeclinePopup
        v-if="isShowDecline"
        @confirmDecline="confirmDecline"
        @close="closeDecline"
    />
</template>

<script lang="ts">
import { DeclineDialog } from "@/dashboard/my-orders/new-popup/decline-dialog/decline-dialog";

export default DeclineDialog;
</script>
